import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const AlertDialog = ({ message, onClose, title = null }) => {
  return (
    <Modal show={true} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title && title.trim() !== "" ? title : "Notification"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AlertDialog;
